<template>
    <v-container class="d-flex-column justify-center">
        <v-card :loading="loading" class="mt-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Στοιχεία Λογαριασμού</h1>
            <v-container fluid class="mt-2">
            </v-container>
          </v-card-title>
          </v-card>
          <v-card class="mt-2">
           <v-tabs
             v-model="vtab"
            align-with-title
            >
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab
            v-for="item in vtabs"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
          </v-card>
          
          
           <v-tabs-items class="mt-2 pa-2" v-model="vtab">
      <!-- <v-tab-item  :key="vtabs[0]">
       <v-row  fluid class="d-flex">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Επισκευές</h1>
            <v-spacer/>
             <v-col cols=12 sm=8 md=6 align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            <v-chip label outlined>
            {{ $tocurr(sumField(this.debits, 'TotalValue')) }}
            </v-chip>
            </v-card-title>
        <v-data-table :headers="headers" :items="repairs"
          :search="search"
          loading: false
          item-key="Id"
          class="elevation-1"
          :items-per-page=15
          show-group-by
          :height="$vuetify.breakpoint.height*0.6"
          :loading="loading" loading-text="Loading... Please wait"
          @click:row="clickrow" >
             
      
          <template v-slot:item.Vehicle.VehType="{ item }">
            <span v-if="!item.Vehicle.VehType">-</span>
            <span v-else>
             <v-icon>{{$vehicleBadges[item.Vehicle.VehType]}}</v-icon>
             <span v-if="$vuetify.breakpoint.mdAndUp">  {{ item.Vehicle.VehType }}</span>
            </span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">More info about {{ item.Id }}</td>
            {{ item.Notes }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :to="{name: 'edit-repair', params: {repairId: item.Id}}"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <new-repair :VehId="item.Id" useIcon="true"/>
          </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="dialog=true">Reset</v-btn>
        </template>
        </v-data-table>
          </v-card>
          </v-col>
          </v-row>
      </v-tab-item> -->
      <v-tab-item :key="vtabs[0]">
      
      <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
    </v-sheet>
     <v-card-text class="pt-0">
     <v-list-item two-line>
         <v-list-item-avatar>
          <img src="../../assets/avatar_erigas.png">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ name }}</v-list-item-title>
            <v-list-item-subtitle>Συνδεδεμένος</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
         <v-list-item two-line>

          <v-list-item-content>
            <v-list-item-title>{{ username }}</v-list-item-title>
            <v-list-item-subtitle>Όνομα χρήστη</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
                <v-divider/>
        <v-list-item>

          <v-list-item-content>
            <v-list-item-title>Αλλαγή κωδικού πρόσβασης</v-list-item-title>
             <v-form
                ref="form"
                v-model="valid"
            >
            <v-text-field label="Κωδικός" v-model="oldPass"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="show1 ? 'text' : 'password'"
            counter
            @click:append="show1 = !show1"
            ></v-text-field>
            <v-text-field label="Νέος Κωδικός" v-model="newPass" 
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min, rules.passDiff]"
            :type="show2 ? 'text' : 'password'"
            counter
            @click:append="show2 = !show2"
            ></v-text-field>
            <v-text-field label="Επιβεβαίωση Κωδικού" v-model="verifyPass" 
            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min, rules.passMatch]"
            :type="show3 ? 'text' : 'password'"
            counter
            @click:append="show3 = !show3"
            ></v-text-field>
            <v-btn
              color="primary"
              dark
              :disabled="!valid"
              @click="changePass"
            >
             <v-icon>mdi-save</v-icon>Αποθηκευση
            </v-btn>
            </v-form>
          </v-list-item-content>
        </v-list-item>
        
    </v-card-text>
  </v-card>

      
    </v-tab-item>
 <v-tab-item :key="vtabs[1]">
      
      <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
    </v-sheet>
     <v-card-text class="pt-0">
        <v-row>
          <v-col>
          <v-select
          v-model="techId"
          :items="technicians"
          item-value="Id"
          item-text="Name"
          label="Tech"
          return-object="true"
        ></v-select> 
        </v-col>
        <v-col>
        <v-select
          v-model="statYear"
          :items="[2023,2024, 2025]"
          label="Είδος Τιμολογίου"
        ></v-select>
        </v-col>
        </v-row> 
     <v-list-item two-line>
         <v-list-item-avatar>
          <img src="../../assets/avatar_erigas.png">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ this.techId.Name }}</v-list-item-title>
            <v-list-item-subtitle>{{ this.techId.JobDesc}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
                <v-divider/>
        <v-list-item two-line>

          <v-list-item-content>
            <v-list-item-title>Στατιστικά</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Κέρδος Συνολικό</v-list-item-title>
            <v-list-item-subtitle>{{ $tocurr(techStats.profits.total) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Κέρδος Ανταλλακτικά</v-list-item-title>
            <v-list-item-subtitle>{{ $tocurr(techStats.profits.parts) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Κέρδος Εργασια</v-list-item-title>
            <v-list-item-subtitle>{{ $tocurr(techStats.profits.service) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        
    </v-card-text>
  </v-card>

      
    </v-tab-item>
    </v-tabs-items>
          
    </v-container>
</template>

<script>


export default {

  components: {
  },
  computed: {
    
    name () {
            if (!localStorage.getItem("userInfo")) return "";
            return JSON.parse(localStorage.getItem("userInfo")).FullName;
    },
    username () {
            if (!localStorage.getItem("userInfo")) return "";
            return JSON.parse(localStorage.getItem("userInfo")).Username;
    },
  },
  watch: {
    async techId() {
      await this.fetchData();
    },
    async statYear() {
      await this.fetchData();
    }

  },
  data() {
    return {
      date: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      valid: false,
      loading: false,
      oldPass: '',
      newPass: '',
      verifyPass: '',
      statYear: 2025,
      techId: {'Name': '', 'JobDesc': ''},
      technicians: [],
      techStats:{profits: {total: 0, parts:0, service:0}, revenue: {total: 0}},
      vtab: null,
      vtabs: ['Ρυθμισεις', 'Στατιστικά'],
      breakdown: {cash: 0, card: 0, check: 0, bank: 0},
      menu: false,
      menu2: false,
      search: "",
      repairs: [],
      show1: false,
      show2: false,
      show3: false,
      rules: {
          required: value => !!value || 'Υποχρεωτικό.',
          min: v => v.length >= 8 || 'Τουλάχιστον 8 χαρακτήρες',
          passDiff: () => ( this.newPass != this.oldPass || `Ο νέος κωδικός είναι ίδιος με τον παλιό`),
          passMatch: () => ( this.newPass === this.verifyPass || `Οι κωδικοί δεν ταιριάζουν`),
        },
      headers: [
        {
          text: "Α/A",
          align: "start",
          //sortable: false,
          value: "Id",
          width: "5%",
        },
        { text: 'Ημ/νία', value: 'Date'},
        {
          text: "Αρ. Κυκλοφορίας",
          align: "start",
          //sortable: false,
          value: "Vehicle.PlateNumber",
          width: "10%",
        },
        { text: "VIN", value: "Vehicle.Vin" },
        { text: "Τύπος", value: "Vehicle.VehType"},
        { text: "Πελάτης", value: "Vehicle.Owner.Name" },
        { text: "Actions", value: "actions", sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
      
    };
  },
  async created() {
    let response = await this.$api.get("/repairs/technicians/")
    this.technicians = response.data;
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    async fetchData() {
    this.loading = true;
       try {
        let response = await this.$api.get("/repairs/technicians/statistics", {
          params: {
            tech_id: this.techId.Id,
            year: this.statYear,
          },
        });
        // console.log(response.data);
        this.techStats = response.data
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    changePass () {
        this.$api.patch("/users/me", {new_password: this.newPass, old_password: this.oldPass}).then(()=> {
        
    
        this.oldPass = '';
        this.newPass = '';
        this.verifyPass = '';
        this.valid=false;
      this.$refs.form.resetValidation();
      }).catch(error => {console.log(error)});
    },
    
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>
